<template>
  <div class="modal-astron">
    <hr />
    <bp-select
      v-model="form.product_id"
      id="product-select"
      class="mb-3"
      label="Nome do produto"
      placeholder="Selecionar produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <div class="row">
      <div class="col-lg-6">
        <bp-input
          v-model="form.description"
          id="description"
          label="Descrição da integração (Opcional)"
          placeholder="Digite a descrição da integração"
          :errors="errors.description"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.url"
          id="url"
          placeholder="Digite a URL"
          label="URL para webhook da Astron Members"
          :errors="errors.url"
          required
        />
      </div>
    </div>

    <div class="submit-buttons">
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
      <bp-button
        label="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(["product_id", "url", "status", "description"], {
        ...this.integrationToEdit,
        product_id: this.integrationToEdit?.product?.id
      })
    };
  },
  methods: {
    submit() {
      this.loading = true;

      let data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.isEdit) {
        data.id = this.integrationToEdit.id;
      } else {
        data.status = true;
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$emit("close");
          this.$message.success("A integração foi salva!");
          this.$emit("update-list");
        })
        .catch(error => {
          this.$message.error(
            error.response?.data.message || "Erro ao salvar integração."
          );
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    isValid() {
      return this.form.product_id && this.form.url;
    }
  }
};
</script>
